import { Action, ActionType } from "@redux/actionTypes/analyticalActionTypes";
import { Reducer } from "redux";

export interface IAnalyticalState {
  analyticalDetailsByPID: IAnalyticalDetailsByPID[];
}

export interface IAnalyticalDetailsByPID {
  projectId: number;
  projectName?: string;
  prototypes: IPrototypes;
  scaleup: IScaleup;
  exhibits: IExhibits;
  // isDraft: boolean;
}
interface IPrototypes {
  headers?: Iheaders[];
  data: Record<string, any>[];
  total?: Record<string, any>[];
  stability?: Record<string, any>[];
  miscellaneousExpenses?: Record<string, any>[];
}

interface IScaleup {
  headers?: Iheaders[];
  data: Record<string, any>[];
  total?: Record<string, any>[];
  stability?: Record<string, any>[];
  miscellaneousExpenses?: Record<string, any>[];
}

interface IExhibits {
  headers?: Iheaders[];
  data: Record<string, any>[];
  total?: Record<string, any>[];
  validationObject?: Record<string, any>[];
  stability?: Record<string, any>[];
  miscellaneousExpenses?: Record<string, any>[];
}

export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
}

const initialState = {
  analyticalDetailsByPID: [],
};

export const analyticalReducer: Reducer<IAnalyticalState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.ANALYTICAL_DETAILS_BY_PID:
      return {
        ...state,
        analyticalDetailsByPID: action.payload,
      };
    case ActionType.RESET_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};
